import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncInviteePage = Load(
  () =>
    import(
      /* webpackChunkName: "withlocals-invitee" */ './components/InviteePage'
    ),
  {},
  true,
);

const InvitationRoutes = [
  <Route
    key="withlocals.invitee"
    path={`${basePath}/join/:bookingId/`}
    component={AsyncInviteePage}
  />,
];

export default InvitationRoutes;
